// ======================================================================
// File Name       : UserAttributeList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form } from 'react-bootstrap';

const UserAttributeList = ({ userAttributes, isCheck }) => {
  const userAttributeList = [];
  for (let i = 1; i <= 20; i++) {
    userAttributeList.push(i);
  }
  const userAttributeView = userAttributeList.map((attribute) => {
    if (!userAttributes.byKeyNum[attribute] || (userAttributes.byKeyNum[attribute]
    && userAttributes.byKeyNum[attribute].userAttribute === '')) return null;
    return (
      <Form.Group className="form-info" key={attribute}>
        <Col
          sm={{
            span: 2,
            offset: 1
          }}
          className="form-label padding-left-clear">
          自由記述領域 {attribute}
        </Col>
        <Col sm={7} className="padding-top-bottom-10">
          {!isCheck && userAttributes.byKeyNum[attribute].userAttribute}
        </Col>
      </Form.Group>
    );
  });
  return (
    <div>
      <Form.Group className="form-info">
        <Col sm={3} className="form-label">自由記述領域</Col>
      </Form.Group>
      {userAttributeView}
    </div>
  );
};

export default UserAttributeList;
